import { defineStore, acceptHMRUpdate } from 'pinia';
import PlanningTimeline from '@/models/PlanningTimeline';
import useUndoRedoStore from '@/stores/undoredo';
import usePlanningStore from './planning';
import usePlanningConfigStore from './config';
import updateVisibleTimeline from './visibleTimeline';

let undoState = {};

/** ******* */
/** INIT * */
/** ******* */
function set(newVals) {
  const planningStore = usePlanningStore();
  const { planning } = planningStore;
  if (Object.getOwnPropertyNames(newVals).length === 0) newVals = new PlanningTimeline();
  planning.timeline.set(newVals);

  if (! planning.timeline.getColWidth()) planning.timeline.setColWidth(planning.timeline.bestColWidth());
  updateVisibleTimeline();
  planningStore.changeTimeline(planning.timeline);
}

function undoredoCols(oldConfig) {
  const planningStore = usePlanningStore();
  const { planning } = planningStore;
  if (angular.equals(planning.timeline, undoState) && (! oldConfig || angular.equals(planning.config, oldConfig))) return;

  const newState = angular.copy(planning.timeline);
  const oldState = angular.copy(undoState);
  let newConfig;
  if (oldConfig) {
    newConfig = angular.copy(planning.config);
  }
  const planningConfigStore = usePlanningConfigStore();
  useUndoRedoStore().add({
    action: () => {
      if (oldConfig) planningConfigStore.set(angular.copy(newConfig));
      set(angular.copy(newState));
    },
    rollback: () => {
      if (oldConfig) planningConfigStore.set(angular.copy(oldConfig));
      set(angular.copy(oldState));
    },
  });
  planningStore.save();
}

const store = defineStore('planning-timeline', {
  actions: {
    addCol({ where, stepIndex }) {
      const planningStore = usePlanningStore();
      const { planning } = planningStore;
      undoState = angular.copy(planning.timeline);

      let mainStep;
      if (typeof stepIndex == 'number' && stepIndex >= 0 && stepIndex < planning.timeline.getSteps().length) {
        mainStep = planning.timeline.getSteps()[stepIndex];
      } else {
        mainStep = planning.timeline.getLastStep();
      }

      if (where == 'first') {
        const newHorizon = planning.timeline.getHiddenBefore().startOf(mainStep);
        if (! newHorizon.isBefore(planning.timeline.getHiddenBefore(), 'minute')) newHorizon.addWithWorkdays(-1, mainStep, planning.timeline.getWorkdays());
        planning.timeline.setHiddenBefore(newHorizon);
      } else {
        const newHorizon = planning.timeline.getHiddenAfter().endOf(mainStep);
        if (! newHorizon.isAfter(planning.timeline.getHiddenAfter(), 'minute')) newHorizon.addWithWorkdays(1, mainStep, planning.timeline.getWorkdays());
        planning.timeline.setHiddenAfter(newHorizon);
      }

      updateVisibleTimeline();
      planningStore.changeTimeline(planning.timeline);
      undoredoCols();

      if (where == "first") {
        $("#table-wrapper").scrollLeft(0);
      } else {
        setTimeout(() => { $("#table-wrapper").scrollLeft(99999); }, 0);
      }
    },
    hideCol({ where, stepIndex }) {
      const planningStore = usePlanningStore();
      const { planning } = planningStore;
      undoState = angular.copy(planning.timeline);

      let mainStep;
      if (typeof stepIndex == 'number' && stepIndex >= 0 && stepIndex < planning.timeline.getSteps().length) {
        mainStep = planning.timeline.getSteps()[stepIndex];
      } else {
        mainStep = planning.timeline.getLastStep();
      }

      if (where == 'first') {
        const newHorizon = planning.timeline.getHiddenBefore().addWithWorkdays(1, mainStep, planning.timeline.getWorkdays()).startOf(mainStep);
        planning.timeline.setHiddenBefore(newHorizon);
      } else {
        const newHorizon = planning.timeline.getHiddenAfter().addWithWorkdays(-1, mainStep, planning.timeline.getWorkdays()).endOf(mainStep);
        planning.timeline.setHiddenAfter(newHorizon);
      }

      updateVisibleTimeline();
      planningStore.changeTimeline(planning.timeline);
      undoredoCols();
    },
    updateTimeline(newVals) {
      const { planning } = usePlanningStore();
      undoState = angular.copy(planning.timeline);

      // save scroll position
      const $tableWrapper = document.getElementById("table-wrapper");
      const scrollPercentage = $tableWrapper && ($tableWrapper.scrollLeft + $tableWrapper.offsetWidth / 2) / $tableWrapper.scrollWidth;

      set(newVals);

      setTimeout(() => {
        // restore scroll position
        if ($tableWrapper) $tableWrapper.scrollLeft = Math.round(scrollPercentage * $tableWrapper.scrollWidth - $tableWrapper.offsetWidth / 2);
      }, 0);

      undoredoCols();
    },
    set,
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
